import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { CommonClient } from "../../parentApi";

const instance = axiosClient();
instance.defaults.headers.common["Cache-Control"] = "no-cache";

const client = new CommonClient(app_uri, instance);

export default client;
